import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Always open blog routes from the top (fixes scroll position carrying between articles). */
export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, [pathname]);

    return null;
}
